import { Component } from 'preact';
import { connect } from 'unistore/preact';
import actions from './actions';
import ThermostatPage from '../ThermostatPage';
import EditForm from './EditForm';
import { DEFAULT_PILOT_WIRE_ORDERS } from '../../../../../../../server/utils/thermostatConstants';

class ThermostatEditPage extends Component {
  // Extracted so a selector change on a reused route reloads the form. Doing this
  // only in componentWillMount left the previous device's values on screen when
  // navigating from one thermostat's edit page to another's.
  loadForSelector(deviceSelector) {
    if (deviceSelector) {
      this.props.getThermostatDevice(deviceSelector);
      return;
    }
    this.props.updateThermostatField('thermostatEditDevice', null);
    this.props.updateThermostatField('thermostatEditName', '');
    this.props.updateThermostatField('thermostatEditMode', 'heating');
    this.props.updateThermostatField('thermostatEditMinTemp', '5');
    this.props.updateThermostatField('thermostatEditMaxTemp', '35');
    this.props.updateThermostatField('thermostatEditTempUnit', 'C');
    this.props.updateThermostatField('thermostatEditControlType', 'hysteresis');
    this.props.updateThermostatField('thermostatEditActiveSchedule', '');
    this.props.updateThermostatField('thermostatEditTemperatureFeatures', []);
    this.props.updateThermostatField('thermostatEditHumidityFeature', '');
    this.props.updateThermostatField('thermostatEditSwitchFeature', '');
    this.props.updateThermostatField('thermostatEditPilotWireFeature', '');
    this.props.updateThermostatField('thermostatEditPilotWireOrders', DEFAULT_PILOT_WIRE_ORDERS);
    this.props.updateThermostatField('thermostatEditType', 'virtual');
    this.props.updateThermostatField('thermostatEditTargetFeature', '');
    this.props.updateThermostatField('thermostatEditStateFeature', '');
    this.props.updateThermostatField('thermostatEditModeFeature', '');
    this.props.updateThermostatField('thermostatEditPowerFeature', '');
    this.props.updateThermostatField('thermostatEditWindowFeatures', []);
    this.props.updateThermostatField('thermostatEditWindowDelay', '60');
    this.props.updateThermostatField('thermostatEditShowAllRooms', false);
    this.props.updateThermostatField('thermostatEditPresetFrost', '7');
    this.props.updateThermostatField('thermostatEditPresetAway', '16');
    this.props.updateThermostatField('thermostatEditPresetEco', '18');
    this.props.updateThermostatField('thermostatEditPresetNight', '17');
    this.props.updateThermostatField('thermostatEditPresetComfort', '21');
    this.props.updateThermostatField('thermostatEditHysteresisStart', '0.5');
    this.props.updateThermostatField('thermostatEditHysteresisStop', '0.5');
    this.props.updateThermostatField('thermostatEditTpiCycleTime', '30');
    this.props.updateThermostatField('thermostatEditTpiProportionalBand', '2');
    this.props.updateThermostatField('thermostatEditRoomId', '');
    this.props.updateThermostatField('thermostatEditManualDuration', '30');
    this.props.updateThermostatField('thermostatEditManualExpiry', 'next-transition');
    this.props.updateThermostatField('thermostatCreateStatus', null);
    this.props.updateThermostatField('thermostatEditError', null);
  }

  componentWillMount() {
    this.props.getDevicesForThermostatEdit();
    this.props.getHouses();
    this.props.getSchedules();
    this.loadForSelector(this.props.deviceSelector);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deviceSelector !== this.props.deviceSelector) {
      this.loadForSelector(nextProps.deviceSelector);
    }
  }

  render(props) {
    return (
      <ThermostatPage user={props.user}>
        <EditForm {...props} />
      </ThermostatPage>
    );
  }
}

export default connect(
  'user,houses,thermostatEditDevice,thermostatEditName,thermostatEditMode,thermostatEditMinTemp,thermostatEditMaxTemp,thermostatEditTempUnit,thermostatEditControlType,thermostatEditTemperatureFeatures,thermostatEditHumidityFeature,thermostatEditSwitchFeature,thermostatEditPilotWireFeature,thermostatEditPilotWireOrders,thermostatEditType,thermostatEditTargetFeature,thermostatEditStateFeature,thermostatEditModeFeature,thermostatEditPowerFeature,thermostatEditWindowFeatures,thermostatEditWindowDelay,thermostatEditShowAllRooms,thermostatEditPresetFrost,thermostatEditPresetAway,thermostatEditPresetEco,thermostatEditPresetNight,thermostatEditPresetComfort,thermostatEditHysteresisStart,thermostatEditHysteresisStop,thermostatEditTpiCycleTime,thermostatEditTpiProportionalBand,thermostatEditRoomId,thermostatEditManualDuration,thermostatEditManualExpiry,thermostatEditError,thermostatEditActiveSchedule,thermostatEditDeviceSchedule,thermostatSchedules,thermostatCreateStatus,temperatureFeatures,humidityFeatures,switchFeatures,pilotWireFeatures,openingFeatures,targetFeatures,stateFeatures,modeFeatures,powerFeatures',
  actions
)(ThermostatEditPage);
